import { render, staticRenderFns } from "./DeleteMenu.vue?vue&type=template&id=622e84a9&"
import script from "./DeleteMenu.vue?vue&type=script&lang=js&"
export * from "./DeleteMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports